module.exports = __webpack_public_path__ + "img/award (4).80282736.jpg";